export default __webpack_public_path__ + "static/media/main-logo.91134c69.png";